import * as types from './actions';
import APIUtil from './../config/APIUtil';
import UrlConstants from './../config/UrlConstants';
import * as code from './../config/Constants';

/**
 *  
 * @desc Get Address from entered zipcode by google map api
 */
export function getAddressFromZipcodeAction(zipcode) {
    let url = UrlConstants.googleMapAPIUrl + zipcode;
    return function (dispatch) {
        return APIUtil.externalAPI(url).then(response => {
            let city = '';
            let state = ''

            if (response.status === code.OK && response.data.status == 'OK') {
                dispatch({
                    type: types.GET_ADD_FROM_ZIPCODE,
                    addressData : response
                });               
                let data = response.data.results[0];
                let address_components = data.address_components;
                for(let i=0;i<address_components.length;i++) {
                    let addComp = address_components[i];
                    if(addComp.types.includes('locality')) {
                        city = addComp.long_name;
                    }
                    if(addComp.types.includes('administrative_area_level_1')) {
                        state = addComp.short_name;						
                    }
                }
            }
            else {
                dispatch({
                    type: types.GET_ADD_FROM_ZIPCODE,
                    addressData: {}
                });
            }
            return {'city':city, "state":state};
        });       
    }
}
